





/** @format */

// {
//         "comp": "TableFilterItem.ParkingLotSearch",
//         "attrs": {
//           "multiple": true
//         }
//       },

/** @format */
import moment from 'moment';
import lodash from 'lodash';
import { Vue } from 'vue-property-decorator';
import inputNumberWithAddon from '@/components/input-number-with-addon/index.vue';
import ParkingReviewImage from '@/components/parking-review-image/index.vue';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import singleFormDictSelect from './comp/singleFormDictSelect.vue';
import mixedUtils from './utils';
import dynamicCompMixin from './dynamic-comp-mixin';
let propsDefine = {
  compDefine: Object,
  vm: Object,
  where: {
    type: [String, Object],
    default: null
  },
  log: Function
};
export default {
  props: propsDefine,
  // watch: {
  //   compDefine: {
  //     deep: true,
  //     handler(nv) {
  //       mixedUtils.log('compDefine nv---:', nv)
  //     },
  //   },
  // },
  computed: {
    // val() {
    //   let returnedVal =
    //     'initialValue' in this.compDefine
    //       ? this.compDefine.initialValue
    //       : this.vm.filterParam[this.compDefine.attrs.httpKey]
    //   mixedUtils.log('returnedVal--:', returnedVal)
    //   return returnedVal
    // },
  },
  mounted() {
    let parentVM = this;
    let dynamicCompCore = Vue.extend({
      name: 'dynamic-comp-core',
      mixins: [dynamicCompMixin],
      components: {
        ParkingReviewImage,
        singleFormDictSelect,
        ParkingLotSearch,
        PlateInput,
        inputNumberWithAddon
      },

      mounted() {
        mixedUtils.log('myDynamicComp--:', this.$refs.myDynamicComp);
        if (this.$refs.myDynamicComp) {
          new Function('p', 'return ' + (parentVM.compDefine.attrs.modifyDomFnWhenInit || '')).call(
            this.$refs.myDynamicComp.$el
          );
        }

        this.$nextTick(() => {
          this.where != null && this.updateModel();
        });
      },
      data() {
        // let firstUpper = parentVM.vm.mixedUtils.firstUpperCase,
        //   typeConstructor =
        //     window[
        //       firstUpper.call(
        //         'array object string boolean number'
        //           .split(' ')
        //           .find(type => parentVM.vm.lodash['is' + firstUpper.call(type)](parentVM.compDefine.initialValue)),
        //       )
        //     ]
        return {
          console: window.console,
          transformedAttrs: {},
          model: parentVM.compDefine.initialValue,
          // model: typeConstructor(),
          // val: null,
          // initialValueCopy: null,
          tempData4FilterParamGenerateCopy: null,
          ...parentVM.$props
        };
      },
      template: (function() {
        let tpl = `<component
      v-bind:is="'${(parentVM.compDefine.reflect || parentVM.compDefine.comp).split('.')[1]}'"
      where="${parentVM.$props.where}"
      ${parentVM.$props.compDefine.twoWayDataBinding ? 'v-model' : ':' + parentVM.compDefine.valueKey}="model"
      ref="myDynamicComp"
      @input="
        handlerModelChangeByType(arguments, compDefine)
      "
      :compDefine="compDefine"
      v-on="
        transformPureStringArray2ObjWithSameFunction(
          compDefine.listeners || [],
          handlerComponentChangeByType.bind(_self, compDefine)
        )
      "
      :vm="vm"
      :style="compDefine.style || {}"
      v-bind="combineObj(compDefine.attrs || {}, {})"
      v-if="compDefine.comp.split('.')[1]"`,
          tplEnd = '></component>';
        tpl += ` tpl="${parentVM.vm.isProd() ? '' : window.encodeURIComponent('')}"${tplEnd}`;
        return tpl;
      })(),
      // destroyed() {
      //   alert('will delete')
      //   // delete this.getClosestVM().dynamicCompInstanceCollectionInDialog[this.compDefine.uuid]
      // },
      created() {
        this.$on('modelUpdate', (v, compDefine) => {
          mixedUtils.log('model update v--:', v);
          parentVM.$emit('modelUpdate', v, compDefine, compDefine.attrs.httpKey);
        });
        // alert('aaa')
        mixedUtils.log('vm in dyanmic crteated---:', this.vm, this.$data);
        if (process.env.NODE_ENV != 'production') {
          window.dynamicComps = (window.dynamicComps || []).concat(this);
        }
        this.$store = parentVM.$store;
        // this.$parent = parentVM
        // mixedUtils.log('store--:', this.$store)
        // this.updateVal(
        //   'initialValue' in this.compDefine
        //     ? this.compDefine.initialValue
        //     : this.vm.filterParam[this.compDefine.attrs.httpKey],
        // )

        this.model = this.compDefine.initialValue;
        // this.initialValueCopy = parentVM.vm.lodash.cloneDeep(this.model)
        this.tempData4FilterParamGenerateCopy = lodash.cloneDeep(this.compDefine.tempData4FilterParamGenerate);
      },

      methods: {
        // getClosestVM() {
        //   return this.MIXIN_VM || mixedUtils.closestVM(this, 'filterParam')
        // },
        // updateVal(newVal) {
        //   this.val = newVal

        //   mixedUtils.log('new val--:', this.val)
        // },
        combineObj(a, b) {
          let res = {
            ...a,
            ...b
          };

          let vm = this.getClosestVM();
          for (var i in res) {
            let v = res[i];
            //为纯字符串生成函数
            if (typeof v === 'string' && v.startsWith('f:')) {
              res[i] = vm
                .generateFunction({
                  f: v.split('f:')[1]
                })
                .bind(vm);
            }
            //为带有=>的字符串生成函数
            if (
              (typeof v === 'string' && v.includes('=>')) ||
              (Array.isArray(v) && v.find(row => typeof row === 'string' && row.includes('=>')))
            ) {
              let fStr = [].concat(v).join('');
              res[i] = new Function(fStr.split('=>')[0].trim(), 'return ' + fStr.split('=>')[1].trim()).bind(vm);
            }
          }

          mixedUtils.log('combine obj res--:', res);

          this.transformedAttrs = res;

          return res;
        },
        // 'initialValue' in item ? item.initialValue : (filterParam[item.attrs.httpKey] = arguments[0])
        handlerComponentChangeByType(compDefine, ...args) {
          mixedUtils.log('argssssssss---:', arguments, args);
          console.log('this---:', this);

          let eventType = args.find(item => 'object' === typeof item && 'EVT_TYPE' in item).EVT_TYPE,
            // let eventType = args[0].type,
            customEvtFnExpression = (compDefine.listeners.find(item => item.startsWith(eventType)) || '')
              // customEvtFnExpression = (compDefine.listeners.find(item => item.startsWith(eventType)) || '')
              .split(':')
              .slice(1)
              .join(':')
              .trim();
          // debugger

          if (customEvtFnExpression) {
            this.$nextTick(() => {
              new Function('p', customEvtFnExpression).call(this.$refs.myDynamicComp.$el, {
                vm: this.getClosestVM(),
                args: [...arguments]
              });
            });
          }

          mixedUtils.log('customEvtFnExpression--:', customEvtFnExpression);

          switch ((compDefine.reflect || compDefine.comp).split('.').reverse()[0]) {
            case 'PlateInput': {
              let [plateHead, plateTail] = args[0];
              let httpKeys = compDefine.attrs.httpKey;

              this.getTargetItemByUuid().tempData4FilterParamGenerate = args[0].map(item => item || '');
              this.getClosestVM().updateFilterParam();

              // if (Array.isArray(httpKeys)) {
              //   this.vm.filterParam[httpKeys[0]] = plateHead
              //   this.vm.filterParam[httpKeys[1]] = plateTail
              // } else {
              //   this.vm.filterParam[httpKeys] = plateHead + plateTail
              // }

              break;
            }
            case 'aRangePicker': {
              mixedUtils.log('arg1--:', args[1]);
              let httpKeys = compDefine.attrs.httpKey;

              if (compDefine.comp == 'span.monthRange') {
                console.log('argsssssssssssssssssssssssssssssssss---:', args);
                this.model = args[0];
                this.$nextTick(() => {
                  parentVM.$emit(
                    'syncMonthRangeValue',
                    [mixedUtils.moment2YM(args[0][0]), mixedUtils.moment2YM(args[0][1])],
                    this.$refs.myDynamicComp
                  );
                });
              } else {
                this.model = args[1].map(item => ('reflect' in compDefine ? item : moment(item)));
              }

              // compDefine.initialValue = args[1].map(str => this.moment(str))
              break;
            }
            case 'aDatePicker': {
              mixedUtils.log('arg1--: of a date picker', args[1], compDefine, typeof args[1]);
              // let httpKeys = compDefine.attrs.httpKey
              // this.vm.filterParam[httpKeys[0]] = args[1][0]
              // this.vm.filterParam[httpKeys[1]] = args[1][1]
              this.model = this.moment(args[1] == '' ? compDefine.foreverDate : args[1]);
              // compDefine.initialValue = args[1].map(str => this.moment(str))
              break;
            }
          }

          // new Function('p', 'return ' + (parentVM.compDefine.attrs.modifyDomFnWhenInit || '')).call(
          //   this.$refs.myDynamicComp.$el,
          // )
        },
        transformPureStringArray2ObjWithSameFunction(arr, fun) {
          let outerSelf = this;
          console.log('funnnnnnnnnn--:', fun);
          let obj = {};
          arr.forEach(str => {
            obj[str.split(':')[0]] = function() {
              let args = [...arguments];
              args.push({
                EVT_TYPE: str.split(':')[0]
              });
              console.log('---args--------:', args);
              fun.apply(outerSelf, args);
            };
          });
          console.log('transformPureStringArray2ObjWithSameFunction  obj--:', obj);
          return obj;
        },

        handlerModelChangeByType(inputParam, compDefine) {
          let target = this.getTargetItemByUuid();
          mixedUtils.log('handlerModelChangeByType arguments-:', arguments, inputParam);
          let compName = compDefine.comp.split('.').reverse()[0];

          mixedUtils.log('comp name--:', compName, inputParam);
          switch (compName) {
            case 'PlateInput': {
              if (inputParam === false) {
                target.tempData4FilterParamGenerate = lodash.cloneDeep(this.tempData4FilterParamGenerateCopy);
                // target.tempData4FilterParamGenerate = args[0].map(item => item || '')
              }
              // this.$nextTick(() => {
              this.getClosestVM().updateFilterParam();
              // })

              mixedUtils.log('该组件的model是一个无用的布尔值，获取不到有意义的值，不予处理');
              break;
            }
            case 'aInput':
            case 'input': {
              this.model = inputParam[0].target.value;
              // alert(inputParam[0].target.value)
              // target.initialValue = inputParam[0].target.value
              // this.vm.filterParam[compDefine.attrs.httpKey] = this.model = inputParam[0].target.value
              // this.vm.filterParam[compDefine.attrs.httpKey] = this.model = inputParam[0].target.value
              break;
            }
            case 'ParkingLotSearch': {
              this.model = inputParam[0];
              // mixedUtils.log('inputParam[0]--:', inputParam[0])
              // target.initialValue = inputParam[0]
              // this.vm.filterParam[compDefine.attrs.httpKey] = this.model = inputParam[0]
              break;
            }
          }
        }
      }
    });
    let compCoreInstance = new dynamicCompCore();

    compCoreInstance.$mount(this.$refs.span);

    this.compCoreInstance = compCoreInstance;
  },
  methods: {
    clearValue() {
      this.compCoreInstance.clearValue();
    }
  }
};
